import { render, staticRenderFns } from "./AccountSetupWizard.vue?vue&type=template&id=50d4e536"
import script from "./AccountSetupWizard.vue?vue&type=script&lang=js"
export * from "./AccountSetupWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports